export enum ReferralsQueryKeys {
  GetAll = 'referrals/getAll',
  Dossier = 'referrals/dossier',
  Create = 'referrals/create',
  Edit = 'referrals/edit',
  Delete = 'referrals/delete',
  Breadcrumb = 'referrals/breadcrumb',
}

export enum ReferralLinksQueryKeys {
  GetAll = 'referral-links/getAll',
  Dossier = 'referral-links/dossier',
  Create = 'referral-links/create',
  Edit = 'referral-links/edit',
  Delete = 'referral-links/delete',
  Breadcrumb = 'referral-links/breadcrumb',
}
